/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Ready_YesInputs */

const en_orders_ready_yes = /** @type {(inputs: Orders_Ready_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YES`)
};

const es_orders_ready_yes = /** @type {(inputs: Orders_Ready_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SI`)
};

/**
* | output |
* | --- |
* | "YES" |
*
* @param {Orders_Ready_YesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_ready_yes = /** @type {((inputs?: Orders_Ready_YesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Ready_YesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_ready_yes(inputs)
	return es_orders_ready_yes(inputs)
});